import React, {useState} from 'react'
import { AiOutlineCloseCircle } from 'react-icons/ai'
import Inputfield from '../InputField/Inputfield'
import DatePicker from "react-datepicker"
import '../Addemployee/addemployee.css'
import './createevent.css'
import axios from 'axios'
import { useCookies } from 'react-cookie';
import moment from "moment";
import NewSelectfield from '../InputField/NewSelectfield'
import DatePicker2 from '../InputField/DatePicker/DatePicker2'


const Createvent = ({sendnotice, params}) => {
    const API = 'https://'
    const [cookies] = useCookies(['Token']);
    const [evenTitle, setEvenTitle] = useState('')

    const [currdate, setCurrdate] = useState()
    const [participants, setParticipants] = useState([])

    const [dates, setDates] = useState({
      startdate: "",
      enddate: ""
    })

    const handleDateSelect = (date) =>{
      setDates({...dates, startdate: moment(date).format('YYYY-MM-DD hh:mm:ss a')})
      setCurrdate(moment(date).format('MM-DD-YYYY'))
    }

    const handleendDateSelect = (date) =>{
      setDates({...dates, enddate: moment(date).format('YYYY-MM-DD hh:mm:ss a')})
    }

    const handleSubmit = async() =>{
        sendnotice({
          action: "load",
          text: 'Sending Data...'
        })
        
        let eventObj = {
          name: evenTitle,
          startDate: dates.startdate,
          endDate: dates.enddate,
          recipients: participants
        }

        try {
          var config = {
            method: 'POST',
            url: `${API}/hr/create/appraisal`,
            data: eventObj,
            headers: { 
              Authorization: "Bearer " + cookies.Token
            }
          };

          // console.log(config)
      
          await axios(config).then((response) => {
          // console.log(response.data.data);
          if(response.data.success === true){
            sendnotice({
              action: "notload",
              text: response.data.message
            })
          }
        });
        } catch(e){
          if(e.message.includes('401')){
            // catch error
          } else{
            // catch error
          }
        }
    }

    const handleCountryname = (incoming) =>{
      setEvenTitle(incoming)
    }

    const handleClose = () =>{
      sendnotice({
        action: "close",
        text: ''
      })
    }

    const selctedParticipants = (incoming) =>{
      setParticipants(participants => [...participants, incoming])
    }

  return (
    <div className='overlay-container'>
            <div className='overlay-event-container'>
                <div className='top-container-apprais-notif'>
                    <span>CREATE NEW EVENT</span>
                    <AiOutlineCloseCircle id='closeIcon-notifc' onClick={handleClose}/>
                </div>

                <div className='top-addemployee-container-body'>
                    <div className='addemployee-addrow'>
                        <div className='addemployee-addrow-cola'>
                          <Inputfield personname={handleCountryname} fieldlabel="Event Title" placehold="Event Title..." typeid="text"/>
                        </div>
                    </div>

                    <div className='top-event-container-body'>
                      <div className='top-event-column1'>
                        <span>Start Date</span>
                        {/* <input className='start-inputfield' placeholder='start date' value={dates.startdate}/> */}
                        <DatePicker2 linestate={false} selected={handleDateSelect} start={true} currentdate={currdate}/>
                      </div>
                      <div className='top-event-column2'>
                        <span>End Date</span>
                        {/* <input className='start-inputfield' placeholder='End date' value={dates.enddate}/>   */}
                        <DatePicker2 linestate={false} selected={handleendDateSelect} start={false} currentdate={currdate}/>
                      </div>
                    </div>

                    <div className='addemployee-addrow'>
                        <div className='addemployee-addrow-cola'>
                            <NewSelectfield fieldlabel="Add Recipients" placehold="Add Recipients..." typeid="select" jdarray={selctedParticipants}/>
                        </div>
                    </div>

                    <div className='top-addemployee-submit-row'>
                        <button id='broadcast-buttn' onClick={handleSubmit}>CREATE</button>
                    </div>
                </div>
            </div>
        </div>
  )
}

export default Createvent